import { isTravelTypeWithHousing } from '@repo/utils'
import React from 'react'
import { useIntl } from 'react-intl'

import AdminActionButton from '../admin-action/AdminActionButton'
import { AdminActionEnum } from '../admin-action/utils/admin-action-data'
import UserPaymentButton from '../user-payment-button/UserButtonPayment'
import PingPongButton from '../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../utils/ping-pong-button-type.enum.ts'
import {
  ClientProposalOutputDto,
  ClientRequestOutputDto,
  NonCompliantRulesFragment,
  Payment_Type,
} from '../../../../../../lib/graphql'
import { useTravelTypeContext } from '../../../../../contexts'
import { IProposalInteractionsProps } from '../../../Proposal'

export interface IUserCanPayDepositFooterProps {
  adminActions: IProposalInteractionsProps['adminActions']
  handleDepositPayment?: () => void
  clientRequest: Pick<ClientRequestOutputDto, '_id' | 'adminCsm' | 'deposit'>
  clientProposal: NonCompliantRulesFragment &
    Pick<
      ClientProposalOutputDto,
      | '_id'
      | 'userCurrentAction'
      | 'clientRequestId'
      | 'houseId'
      | 'permissions'
      | 'serviceProviderId'
    >
}

const UserCanPayDepositFooter = ({
  adminActions,
  handleDepositPayment,
  clientProposal,
  clientRequest,
}: IUserCanPayDepositFooterProps) => {
  const intl = useIntl()
  const { travelType } = useTravelTypeContext()

  const adminSkippedDepositPayment = adminActions?.adminSkippedDepositPayment

  if (!clientRequest.deposit?.status) {
    throw new Error('clientRequest.deposit.status is required')
  }

  const buttonLabel = !isTravelTypeWithHousing(travelType)
    ? intl.formatMessage({
        id: 'ui.userCurrentActionButton.userCanPayDeposit.button.bookingConfirmedByOwner',
        defaultMessage: 'Réservation confirmée par le prestataire',
      })
    : intl.formatMessage({
        id: 'ui.userCurrentActionButton.userCanPayDeposit.button.bookingConfirmedByServiceProvider',
        defaultMessage: "Réservation confirmée par l'hôte",
      })

  return (
    <>
      <div className='flex w-full flex-col gap-3 py-5'>
        <PingPongButton
          label={buttonLabel}
          type={PingPongButtonTypeEnum.CONFIRMED_BY_OWNER}
          hideIcon={true}
        />

        <UserPaymentButton
          clientRequestId={clientRequest._id}
          houseId={clientProposal.houseId}
          serviceProviderId={clientProposal.serviceProviderId}
          payment={{
            paymentType: Payment_Type.DEPOSIT,
            paymentAmount:
              clientRequest.deposit?.price?.totalUser?.priceWithDiscountAndFees
                ?.priceWithVat ?? 0,
            paymentStatus: clientRequest.deposit?.status,
          }}
          handlePayment={handleDepositPayment}
        />

        {clientProposal.permissions.canValidateStepThreeWithoutDepositPayment &&
          adminSkippedDepositPayment && (
            <AdminActionButton
              adminAction={AdminActionEnum.SKIP_DEPOSIT_PAYMENT}
              onClickConfirm={() =>
                adminSkippedDepositPayment.callback({
                  clientProposalId: clientProposal._id,
                })
              }
              isLoading={adminSkippedDepositPayment.isLoading}
            />
          )}
      </div>
    </>
  )
}

export default UserCanPayDepositFooter
